import { createApiHooks } from './createApiHook';
import { createApiQueries, createApiQueriesClient, createApiUseQueries } from './createApiQuery';
import { createApiFetchClient } from '../../apis-infra';
import { createApiClientProvider } from './createApiClientProvider';
import { useApisClientContext } from '../Providers';
export function createApiClient(apiConfig) {
  const fetchApi = createApiFetchClient(apiConfig);
  const hooks = createApiHooks({
    apiConfig
  });
  const apiQueries = createApiQueries({
    apiConfig
  });
  const queriesClient = createApiQueriesClient({
    apiConfig,
    apiQueries
  });
  const useQueries = createApiUseQueries({
    apiQueries
  });
  const Provider = createApiClientProvider(apiConfig);
  const useHttpClient = () => useApisClientContext().httpClient;
  return {
    fetch: fetchApi.fetch,
    query: apiQueries,
    hooks,
    useQueries,
    queries: queriesClient,
    Provider,
    useHttpClient
  };
}
//# sourceMappingURL=createApiClient.js.map